<script lang="ts">
import { useNhostClient } from '@nhost/vue';
import { useClientStore } from '@/store/client';
import { usePermissionStore } from '@/store/permission';
import { mapState } from 'pinia';
import { gql } from '@apollo/client/core';

const GET_CUSTOM_DOMAIN = gql`
  query GetCustomDomain($client_id: uuid!) {
    general_module_configuration_dataroom(where: { client_id: { _eq: $client_id } }) {
      custom_domain
    }
  }
`;

export default {
  setup() {
    const permissionStore = usePermissionStore();
    return {
      permissionStore,
    };
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(useClientStore, ['selectedClient']),
  },
  async created() {
    const client = useNhostClient();

    try {
      const response = await client.nhost.auth.refreshSession();
      let redirectUrl = import.meta.env.VITE_DATAROOM_REDIRECT_URL;

      // Check if user has only one permission and it's dataroom.read
      const userPermissions = this.permissionStore.permissions;
      const hasOnlyDataroomRead = userPermissions.length === 1 && userPermissions[0] === 'dataroom.read';

      if (hasOnlyDataroomRead && this.selectedClient?.id) {
        try {
          // Query for custom domain
          const result = await this.$apollo.query({
            query: GET_CUSTOM_DOMAIN,
            variables: {
              client_id: this.selectedClient.id,
            },
            fetchPolicy: 'network-only',
          });

          // Use custom domain if available
          if (result.data.general_module_configuration_dataroom?.[0]?.custom_domain) {
            let customDomain = result.data.general_module_configuration_dataroom[0].custom_domain;

            // Ensure custom domain has protocol (https://)
            if (!customDomain.startsWith('http://') && !customDomain.startsWith('https://')) {
              customDomain = `https://${customDomain}`;
            }

            // Ensure custom domain ends with proper path and query parameter
            redirectUrl = customDomain.endsWith('/sign-in?token=')
              ? customDomain
              : `${customDomain}/sign-in?token=`;
          }
        } catch (error) {
          console.error('Error fetching custom domain:', error);
          // Fall back to default URL if query fails
        }
      }

      // Redirect to the appropriate URL
      window.location.replace(`${redirectUrl}${response.session?.refreshToken}&client_id=${this.selectedClient?.id}`);
    } catch (error) {
      console.error('Error refreshing session:', error);
    }
  },
};
</script>

<template>
  <main></main>
</template>
